import initialiseHandlers from "./initialise-handlers.js";
import destroyHandlers from "./destroy-handlers.js";

const handler = {
	initialiseHandlers,
	destroyHandlers,
};

export default handler;
